<template>
  <div>
    <v-container>
      <field-label label="Fluxo de respostas" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <csu-diagnosis-flux-graph :fluxNumbers="fluxNumber" />
      </field-label>
      <field-label label="" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <v-row dense class="mt-1">
          <v-col>
            <field-label label="UAS7" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--yellow': computedUas7 == 1,
                  'big-number--orange': computedUas7 == 2,
                  'big-number--red': computedUas7 == 3,
                  'grey--text text-lighten-1': computedUas7 === '?',
                }"
                >{{ computedUas7 }}</span
              >
            </field-label>
          </v-col>
          <v-col>
            <field-label label="UCT" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedUct > 9,
                  'grey--text text-lighten-1': computedUct === '?',
                }"
                >{{ computedUct }}</span
              >
            </field-label>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col>
            <field-label label="CUQ2OL" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--negative': computedCuq2ol > 9,
                  'grey--text text-lighten-1': computedCuq2ol === '?',
                }"
                >{{ computedCuq2ol }}</span
              >
            </field-label>
          </v-col>
        </v-row>
      </field-label>
      <field-label label="Qualidade de vida" titleClass="text-h6" titleColorClass="grey--text text--darken-2">
        <v-row dense class="mt-1">
          <v-col>
            <field-label label="DLQI" class="fill-height d-flex flex-column">
              <span
                class="big-number mt-auto"
                :class="{
                  'big-number--orange': computedDlqi > 1 && computedDlqi <= 9,
                  'big-number--negative': computedDlqi > 9,
                  'grey--text text-lighten-1': computedDlqi === '?',
                }"
                >{{ computedDlqi }}</span
              >
            </field-label>
          </v-col>
        </v-row>
      </field-label>
    </v-container>
  </div>
</template>
<script>
import CsuDiagnosisFluxGraph from '@//components/AttendanceForm/csu/summary/CsuDiagnosisFluxGraph.vue'
import BaseSummary from '@/components/AttendanceForm/general/summary/BaseSummary.vue'
import FieldLabel from '@/components/FieldLabel.vue'

import csuSummaryMixin from '@/components/AttendanceForm/csu/mixins/csuSummaryMixin.js'

import { DIAGNOSIS_OPTIONS } from '@/components/AttendanceForm/csu/constants/diagnosis'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  mixins: [csuSummaryMixin],
  extends: BaseSummary,
  components: { FieldLabel, CsuDiagnosisFluxGraph },

  computed: {
    ...attendanceGettersMap(['attendance', 'getPhaseDataByKey']),
    fluxNumber() {
      if (!this.attendance.data?.diagnostico) {
        return {}
      }
      const diagnosisKyeIndex = {}
      const phaseData = this.attendance.data.diagnostico
      Object.values(DIAGNOSIS_OPTIONS).forEach((option) => {
        // const diagnosisKyeIndexItem =
        //   option.key !== 'sintomas_induziveis' ? phaseData[option.key] : phaseData[option.key].value
        const diagnosisKyeIndexItem = {}
        if (phaseData[option.key] !== undefined && phaseData[option.key] !== null) {
          // console.log(option.index, phaseData[option.key])
          diagnosisKyeIndex[option.index] = option.index !== 7 ? phaseData[option.key] : phaseData[option.key].value
        }
      })

      return diagnosisKyeIndex
    },
  },

  methods: {
    getSummaryData() {
      const data = {
        uas7: { value: this.computedUas7 ?? '', text: 'UAS7' },
        uct: { value: this.computedUct ?? '', text: 'UCT' },
        dlqi: { value: this.computedDlqi ?? '', text: 'DLQI' },
        cuq2ol: { value: this.computedCuq2ol ?? '', text: 'CUQ2OL' },
      }
      return data
    },
  },
}
</script>

<style scoped>
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}
.big-number--negative {
  color: red;
}
.big-number--green {
  color: green;
}
.big-number--yellow {
  color: yellow;
}
.big-number--orange {
  color: orange;
}
.big-number--red {
  color: red;
}
.extra-info::after {
  content: '*';
  font-size: 16px;
  color: black;
  vertical-align: text-top;
}
</style>
